import http from '@/http'
const URL = '/admin/customization'

export const getCustomization = async () => {
  const data = (await http.get(URL))
  return data
}

export const saveCustomization = (payload) => {
  return http.post(URL, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const deleteImage = (field) => {
  return http.delete(URL + `/image`, { data: { field } })
}

export default {
  getCustomization,
  saveCustomization,
  deleteImage
}
